import {
  ISO_COUNTRY_CODES,
  type IsoCountryCode,
  isoCountryDisplayName,
  isoCountryFlagEmoji,
} from "@v1/backend/logic/billing/iso_countries";
import {
  getCountryCallingCode,
  parsePhoneNumberFromString,
} from "libphonenumber-js";
import type { CountryCode } from "libphonenumber-js";

export type { IsoCountryCode as CountryCode };

export const BOOKING_PHONE_COUNTRIES: CountryCode[] = ISO_COUNTRY_CODES;

export function flagEmoji(iso: CountryCode): string {
  return isoCountryFlagEmoji(iso);
}

export function countryName(iso: CountryCode): string {
  return isoCountryDisplayName(iso);
}

export { getCountryCallingCode };

export function detectCountryFromPhoneValue(value: string): CountryCode | null {
  if (!value.startsWith("+")) return null;
  try {
    const parsed = parsePhoneNumberFromString(value);
    return (parsed?.country as CountryCode) ?? null;
  } catch {
    return null;
  }
}
